import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { Typography, Box } from "@mui/material"

import { formatChartNumber } from "./utils/numberFormat"
import OverviewCard, {
  overviewCardValueSx,
  overviewCardHelperTextSx,
} from "./OverviewCard"

const detailLabelSx = { fontSize: 12, color: "#6b7280" }
const detailValueSx = { fontSize: 12, fontWeight: 600, color: "#414141" }

const WorkCertifiedAmountsCard = ({
  certifiedAccumulated,
  periodCertified,
  isLoading,
  currency,
}) => (
  <OverviewCard
    iconPreset="registeredAdvance"
    title={i18n.t("overview.workCertificationAmountsCardTitle")}
    infoText={i18n.t("overview.workCertificationAmountsCardTooltip")}
    loading={isLoading}
    sx={{ width: "100%", height: "100%" }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Box>
        <Typography sx={overviewCardValueSx}>
          {formatChartNumber(certifiedAccumulated, 2)} {currency}
        </Typography>
        <Typography variant="body2" sx={overviewCardHelperTextSx}>
          {i18n.t("overview.workCertificationAmountsAccumulatedLabel")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          alignItems: "baseline",
        }}
      >
        <Typography sx={detailLabelSx}>
          {i18n.t("overview.workCertificationAmountsPeriodHelper")}:
        </Typography>
        <Typography sx={detailValueSx}>
          {formatChartNumber(periodCertified, 2)} {currency}
        </Typography>
      </Box>
    </Box>
  </OverviewCard>
)

WorkCertifiedAmountsCard.propTypes = {
  certifiedAccumulated: PropTypes.number.isRequired,
  periodCertified: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  currency: PropTypes.string,
}

WorkCertifiedAmountsCard.defaultProps = {
  isLoading: false,
  currency: "",
}

export default WorkCertifiedAmountsCard
